import { z } from "zod"
import { OrderInformationSchema } from "../orderInformation"
import { ShopifyMetafieldEntrySchema, ShopifyMetafieldsConfigSchema } from "./metafieldsConfig"

export const ShopifyIntegrationResponseDataSchema = z.object({
  shopifyUrl: z.string().optional(),
  shopifyHash: z.string().optional(),
  accessToken: z.string().optional(),
  prefix: z.string().nullish(),
  suffix: z.string().nullish(),
  appVersion: z.string().nullish(),
  enableSizeCharts: z.boolean().optional(),
  isOrderFulfilledWebhookActive: z.boolean().optional(),
  isAbandonCheckoutWebhookActive: z.boolean().optional(),
  metafieldsConfig: ShopifyMetafieldsConfigSchema.optional(),
  activeWidgetCampaignId: z.bigint().transform(String).nullable().optional(),
  themeEditorUrl: z.string().nullable().optional(),
})

export const ConvertSizeChartResponseData = z.object({
  collection: z.string(),
  styleName: z.string(),
  result: z.object({
    convertToInches: z.boolean().default(false),
    columns: z.array(z.string()),
    sizes: z.array(
      z.object({
        label: z.string(),
        values: z.array(z.string()),
      }),
    ),
  }),
})

const SizeChartImagePointSchema = z.object({
  x: z.number(),
  y: z.number(),
})

export const ConvertSizeChartPermutConfigSchema = z.object({
  version: z.literal(1),
  table: ConvertSizeChartResponseData.shape.result,
  imageUrl: z.string(),
  imageTransform: z
    .object({
      offset: SizeChartImagePointSchema,
      scale: z.number(),
    })
    .optional(),
  labels: z.array(
    z.object({
      id: z.string(),
      text: z.string(),
      start: SizeChartImagePointSchema,
      end: SizeChartImagePointSchema,
      guide: SizeChartImagePointSchema,
    }),
  ),
})

const ShopifyProductPriceRangeResponseDataSchema = z.object({
  min: z.number(),
  max: z.number(),
  currency: z.string(),
})

const ShopifyProductOptionResponseDataSchema = z.object({
  name: z.string(),
  values: z.array(z.string()),
})

const ShopifyProductVariantResponseDataSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
  sku: z.string().nullable(),
  selectedOptions: z.array(z.object({ name: z.string(), value: z.string() })),
})

export const ShopifyProductResponseDataSchema = z.object({
  id: z.string(),
  title: z.string(),
  status: z.enum(["ACTIVE", "ARCHIVED", "DRAFT", "UNLISTED"]).nullish(),
  category: z.string().nullable(),
  description: z.string().nullable(),
  priceRange: ShopifyProductPriceRangeResponseDataSchema,
  imageUrl: z.string().nullable(),
  url: z.string(),
  tags: z.array(ShopifyMetafieldEntrySchema).optional(),
  options: z.array(ShopifyProductOptionResponseDataSchema),
  collections: z.array(z.string()),
  variants: z.array(ShopifyProductVariantResponseDataSchema).optional(),
})

export const ShopifyProductsResponseDataSchema = z.array(ShopifyProductResponseDataSchema)

export const ShopifyGetOrderInfoResponseData = OrderInformationSchema

export const SizeChartGenerateImageResponseData = z.object({
  base64Image: z.string(),
  url: z.string(),
})

export const CloneConvertSizeChartResponseData = z.object({
  imageUrl: z.string().nullable(),
  metafieldValue: z.string().nullable(),
  permutConfig: z.string().nullable(),
})
